import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const token = localStorage.getItem("token");
  const role = (localStorage.getItem("userRole") || "").toLowerCase();

  if (!token) return <Navigate to="/login" />;

  const allowedRolesLower = allowedRoles.map(r => r.toLowerCase());
  if (allowedRoles.length > 0 && !allowedRolesLower.includes(role)) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
